import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import {
  Alert,
  Button,
  Chip,
  LinearProgress,
  Stack,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import Coronavirus from '@mui/icons-material/Coronavirus'
import PriorityHigh from '@mui/icons-material/PriorityHigh'
import API from '../../../../services/API'
import CustomDataGrid from '../../../../components/DataGrid/CustomDataGrid'
import { getStatusColor } from '../../../../components/Kanban/KanbanTab'
import { SectionHeader } from './SectionKit'

const DefectsSection = ({ vehicleID }) => {
  const [loading, setLoading] = useState(true)
  const [defects, setDefects] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    API.get('/vehicle-defects/' + vehicleID)
      .then((res) => {
        if (res.status === 200) setDefects(res.data)
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false))
  }, [vehicleID])

  return (
    <Stack spacing={1.5}>
      <SectionHeader
        title="Defects"
        caption="Active defects reported against this vehicle"
        action={
          <Button
            size="small"
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => navigate('/report-defect?vehicleID=' + vehicleID)}
          >
            Report Defect
          </Button>
        }
      />
      {loading ? (
        <LinearProgress />
      ) : defects.length === 0 ? (
        <Alert severity="success">No active defects on this vehicle.</Alert>
      ) : (
        <CustomDataGrid
          rows={defects}
          getRowId={(row) => row._id}
          columns={[
            {
              field: 'createdAt',
              headerName: 'Date',
              minWidth: 110,
              renderCell: ({ value }) => moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'isIPC',
              headerName: 'IPC',
              minWidth: 70,
              align: 'center',
              headerAlign: 'center',
              renderCell: ({ value }) =>
                value ? <Coronavirus color="error" /> : null,
            },
            {
              field: 'priority',
              headerName: 'Priority',
              minWidth: 110,
              renderCell: ({ row }) => (
                <Stack direction="row">
                  {Array.from({ length: row.priority }).map((_, i) => (
                    <PriorityHigh
                      key={i}
                      fontSize="small"
                      color={
                        row.priority === 3
                          ? 'error'
                          : row.priority === 2
                            ? 'warning'
                            : 'success'
                      }
                    />
                  ))}
                </Stack>
              ),
            },
            {
              field: 'summary',
              headerName: 'Summary',
              flex: 1,
              minWidth: 220,
            },
            {
              field: 'status',
              headerName: 'Status',
              minWidth: 150,
              renderCell: ({ row }) => (
                <Chip
                  size="small"
                  sx={{ borderRadius: 1, width: '100%' }}
                  label={row.status}
                  color={getStatusColor(row?.status ?? '')}
                />
              ),
            },
          ]}
          disableRowSelectionOnClick
          onRowClick={({ row }) => navigate('/defects/' + row._id)}
          slots={{ toolbar: () => null, footer: () => null }}
        />
      )}
    </Stack>
  )
}

export default DefectsSection
